import { Download } from 'lucide-react';

import { ActionButton } from '@/_containers/actions';
import { downloadFile, useBoolean } from '@/_shared';

interface FileDownloadButtonProps {
  fileUrl?: string;
  fileName: string;
  className?: string;
}

export function FileDownloadButton({ fileUrl, fileName, className = '' }: FileDownloadButtonProps) {
  const [isDownloading, downloadFileState] = useBoolean();

  const handleDownloadFile = async () => {
    if (fileUrl && !isDownloading) {
      downloadFileState.setTrue();

      try {
        await downloadFile(fileUrl, fileName);
      } catch {
        try {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch {
          window.open(fileUrl, '_blank', 'noopener,noreferrer');
        }
      } finally {
        downloadFileState.setFalse();
      }
    }
  };

  if (!fileUrl) return null;

  return (
    <ActionButton
      size="sm"
      title="Download File"
      tag="button"
      icon={Download}
      type="icon"
      onClick={handleDownloadFile}
      disabled={isDownloading}
      showLoader={isDownloading}
      className={className}
    />
  );
}
